import { pickGmwLibraryFields } from "../../../schema/gmw-schema-library";

import type { SourcedocumentDataSchemaFor } from "./_gmw-event-schema-collection";

export const gmwInsertionSchema: SourcedocumentDataSchemaFor<"GMW_Insertion"> = {
  type: "object",
  title: "Gebeurtenis gegevens",
  required: [
    "eventDate",
    "insertedPartLength",
    "insertedPartDiameter",
    "insertedPartMaterial",
    "tubeNumber",
    "tubeTopPosition",
    "tubeTopPositioningMethod",
  ],
  properties: pickGmwLibraryFields([
    "eventDate",
    "insertedPartLength",
    "insertedPartDiameter",
    "insertedPartMaterial",
    "tubeNumber",
    "tubeTopPosition",
    "tubeTopPositioningMethod",
  ]),
};
